import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UserHelper } from '@helpers/user.helper';
import { DataHelper } from '@helpers/data.helper';
import { UiHelper } from '@helpers/ui.helper';
import { TranslatePipe } from '@app/pipes/translate.pipe';

// export interface IStandart_Limit_Array {
//   limit_type: string;
//   limit_amount: number;
//   limit_name: string;
//   limit_time_type: string;
// }
export interface IStandart_Limit_Model {
  CustomerLimitId: number;
  StakeDailyLimit: number;
  StakeWeeklyLimit: number;
  StakeMonthlyLimit: number;
  DepositDailyLimit: number;
  DepositWeeklyLimit: number;
  DepositMonthlyLimit: number;
  LossDailyLimit: number;
  LossWeeklyLimit: number;
  LossMonthlyLimit: number;
}
@Component({
  selector: 'reset-limit-dialog',
  templateUrl: '../sharedTemplates/reset-limit.dialog.html',
})
export class ResetLimitDialog {
  // standart_limit_array: Array<IStandart_Limit_Array> = [
  //   //Stake
  //   {
  //     limit_type: '1',
  //     limit_time_type: '1',
  //     limit_amount: 1000000,
  //     limit_name: "Stake Daily Limit"
  //   },
  //   {
  //     limit_type: '1',
  //     limit_time_type: '2',
  //     limit_amount: 1000000,
  //     limit_name: "Stake Weekly Limit"
  //   },
  //   {
  //     limit_type: '1',
  //     limit_time_type: '3',
  //     limit_amount: 1000000,
  //     limit_name: "Stake Monthly Limit"
  //   },

  //   //Deposit
  //   {
  //     limit_type: '2',
  //     limit_time_type: '1',
  //     limit_amount: 30000,
  //     limit_name: "Deposit Day Limit"
  //   },
  //   {
  //     limit_type: '2',
  //     limit_time_type: '2',
  //     limit_amount: 30000,
  //     limit_name: "Deposit Week Limit"
  //   },

  //   //Lost
  //   {
  //     limit_type: '3',
  //     limit_time_type: '1',
  //     limit_amount: 200000,
  //     limit_name: "Loss Day Limit"
  //   },
  //   {
  //     limit_type: '3',
  //     limit_time_type: '2',
  //     limit_amount: 200000,
  //     limit_name: "Loss Week Limit"
  //   },
  //   {
  //     limit_type: '3',
  //     limit_time_type: '3',
  //     limit_amount: 200000,
  //     limit_name: "Loss Month Limit"
  //   },

  // ]
  standart_limit_object: IStandart_Limit_Model = {
    CustomerLimitId: 0,
    StakeDailyLimit: 1000000,
    StakeWeeklyLimit: 1000000,
    StakeMonthlyLimit: 1000000,
    DepositDailyLimit: 30000,
    DepositWeeklyLimit: 30000,
    DepositMonthlyLimit: 0,
    LossDailyLimit: 200000,
    LossWeeklyLimit: 200000,
    LossMonthlyLimit: 200000,
  };

  constructor(
    public dialogRef: MatDialogRef<ResetLimitDialog>,
    private _ApiService: ApiService,
    public _LocalizationService: LocalizationService,
    public _UserHelper: UserHelper,
    public _DataHelper: DataHelper,
    public _UiHelper: UiHelper
  ) {
    this.getSelfLimits();
  }

  getSelfLimits() {
    this._ApiService.getSelfLimits().then(x => {
      if (x && x.length > 0) {
        //
        this.standart_limit_object.DepositMonthlyLimit = x[0].DepositMonthlyLimit;
        this.standart_limit_object.CustomerLimitId = x[0].CustomerLimitId;
      }
    });
  }

  //Promise.all yapısıyla bir yapı kuruldu bu yüzden yorum satırları açık bırakıldı.tekrar kullanılabilir diye kaldırmadım.

  // saveSelfLimitsData() {

  //   const apicalls: Promise<any>[] = [];

  //   for (let index = 0; index < this.standart_limit_array.length; index++) {

  //     const element = this.standart_limit_array[index];
  //     apicalls.push(this._ApiService.saveSelfLimits2(element.limit_amount, element.limit_type, element.limit_time_type))
  //   }
  //   this.dialogRef.close();
  //   return Promise.all(apicalls);

  // }

  resetSelfLimits() {
    const translator = new TranslatePipe(this._LocalizationService);
    this._ApiService.saveSelfLimits(this.standart_limit_object).then(result => {
      if (result) {
        if (result.code == '') {
          return 'error|System Error';
        } else {
          if (result.code == 'error') {
            this._UiHelper.errorSnackBar(result.message, '');
          } else if (result.code == 'errorcode') {
            const t_message = translator.transform(result.message, null);
            this._UiHelper.errorSnackBar(t_message, '');
          } else if (result.code == 'success') {
            const t_message = translator.transform(result.message, null);
            this._UiHelper.successSnackBar(t_message, '');
            this.dialogRef.close();
          }
        }
      }
    });
  }
}
